import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { MessageSquare, Zap } from 'lucide-mui';
import useLimits from '../../plan/hooks/limits';

const TranscriptLimitReached: React.FC = () => {
  const [open, setOpen] = useState(false);
  const guardLimits = useLimits();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpgradeClick = () => {
    guardLimits('transcription', () => {
      console.log('Upgrade process initiated for transcription feature.');
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100vh"
      textAlign="center"
      p={1}
    >
      <MessageSquare sx={{ fontSize: 45, color: 'secondary.main' }} />
      <Typography variant="h5" color="textPrimary" mt={2}>
        Ask AI Requires a Transcript
      </Typography>
      <Typography variant="body1" color="textSecondary" mt={1}>
        You&apos;ve reached your transcript limit and can&apos;t use the
        &quot;Ask AI&quot; feature. Upgrade your plan to continue.
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClickOpen}
        sx={{ mt: 2 }}
      >
        Learn More
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Why Can&apos;t I Use &quot;Ask AI&quot;?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            &quot;Ask AI&quot; uses transcripts to understand your audio or
            video content. Transcripts are text versions of what is spoken in
            your recordings.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            You&apos;ve hit the limit of transcripts your plan allows. Upgrade
            to transcribe and keep using &quot;Ask AI&quot;.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Zap />}
            onClick={handleUpgradeClick}
            sx={{ ml: 2 }}
          >
            Upgrade
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TranscriptLimitReached;
